import type { Attachment, AttachmentType } from 'pkg/api/models/attachment';

export enum FormFieldTypes {
	Text = 'Text',
	LongText = 'LongText',
	Number = 'Number',
	Date = 'Date',
	Select = 'Select',
	MultiSelect = 'MultiSelect',
	Attachment = 'Attachment',
	Email = 'Email',
	PhoneNumber = 'PhoneNumber',
	Dropdown = 'Dropdown',
	Section = 'Section',
	Slider = 'Slider',
}

export enum OutputFields {
	Values = 'Values',
	Fields = 'Fields',
	OptionIds = 'OptionIDs',
	AttachmentIds = 'AttachmentIDs',
}

export interface FormFieldOption {
	key: number;
	label: string;
	maxSubmissions?: number;
	currentSubmissions?: number;
}

export interface FormFieldSliderOption {
	value: number;
	label: string;
}

export interface FormFieldV2 {
	type: FormFieldTypes;
	key?: string;
	label: string;
	outputField: OutputFields;
	outputKey: number | string;
	required?: boolean;
	readonly?: boolean;
	default?: unknown;
	defaultValues?: number[];
	description?: string;
	options?: FormFieldOption[];
	attachmentType?: AttachmentType;
	attachments?: Attachment[];
	min?: FormFieldSliderOption;
	max?: FormFieldSliderOption;
}
export interface FormProductPrice {
	productPriceId: number;
	qty?: number;
	taxRateId?: number;
	validTo?: number;
}

export interface EligiblePackagesPayload {
	values?: { [key: number]: unknown };
	optionIds?: { [key: number]: number[] };
	submittingForAccountId?: number;
	skipEligibilityRules?: boolean;
}
